<template>
	<div id="Group">
		<div v-if="showMediaManager" class="media--manager">
			<div class="nav-mediaManager p-4">
				<i class="fas fa-chevron-down" @click="showMediaManager = false"></i>
			</div>
			<MediaManager @receiveMedias="addPictures($event)" />
		</div>
		<div class="row" v-if="alertRemove">
			<div class="col-12 text-left">
				<p style="color: #FF4040">É necessário ao menos uma foto na galeria.</p>
			</div>
		</div>
		<div class="row text-center mx--2 align-items-top">
			<draggable
				:force-fallback="true"
				v-if="arrayImages"
				v-bind="{ draggable: '.drag', handle: '.drag' }"
				v-model="arrayImages"
				class="row m-0"
				@change="updateFrameContentPictures(arrayImages)"
			>
				<div class="drag col-3" v-for="(item, index) in arrayImages" :key="index">
					<div class="hover-shadow cursor position-relative mb-4">
						<img
							v-if="item.type == 'page'"
							class="img-galery rounded"
							:src="CDN_URL + item.contents.mainImage"
							alt
						/>
						<img v-else class="img-galery rounded" :src="CDN_URL + item.contents.url" alt />
						<div class="position-absolute ps-b-0 ps-r-0 m-2">
							<button class="btn btn-block btn-primario px-2 py-0" @click="removePhotoFromGalery(index)">
								<i class="fal fa-trash-alt font-14"></i>
							</button>
						</div>
					</div>
				</div>
			</draggable>
			<div class="col-12">
				<hr />
				<button class="btn btn-primario py-2 px-3" @click="showMediaManager = true">
					<i class="fal fa-plus"></i> Adicionar
				</button>
			</div>
		</div>
	</div>
</template>
<script>
import draggable from "vuedraggable";
import axios from "axios";
import ImageBlock from "@/components/blocks/ImageBlock";
import VueGallery from "vue-gallery";
export default {
	name: "Group",
	data() {
		return {
			showMediaManager: false,
			alertRemove: false,
			index: null,
			arrayImages: [],
			files: "",
			CDN_URL: null,
			ROOT_API: null,
		};
	},
	props: {
		itensGroup: {
			type: Array,
		},
		siteId: {
			type: Number,
			required: true,
		},
	},
	components: {
		MediaManager: () => import("../organisms/MediaManager"),
		ImageBlock,
		gallery: VueGallery,
		draggable,
	},
	created() {
		this.CDN_URL = process.env.CDN_URL;
		this.ROOT_API = process.env.ROOT_API;
		this.arrayImages = [...this.itensGroup];
	},
	methods: {
		addPictures(pictures) {
			this.arrayImages = [
				...this.arrayImages,
				...pictures.map((picture) => ({
					type: "image",
					contents: {
						height: "",
						url: picture,
						width: "",
					},
				})),
			];
			this.showMediaManager = false;
			this.updateFrameContentPictures(this.arrayImages);
		},
		updateFrameContentPictures(picturesArray) {
			this.$emit("updateContent", picturesArray);
		},
		removePhotoFromGalery(index) {
			if (this.arrayImages.length > 1) {
				this.arrayImages.splice(index, 1);
				this.updateFrameContentPictures(this.arrayImages);
			} else {
				this.alertRemove = true;
				setTimeout(() => {
					this.alertRemove = false;
				}, 2500);
			}
		},
		openInput(frameId) {
			document.getElementById("uploadPictures" + frameId).click();
		},
		handleUploadImage() {
			this.$emit("handleLoading", true);
			this.files = this.$refs.uploadPictures.files;
			let formData = new FormData();
			let token = this.$session.get("jwt");
			let siteId = this.$session.get("siteId");
			for (var i = 0; i < this.files.length; i++) {
				let file = this.files[i];
				formData.append("images[]", file);
				formData.append("siteId", this.$session.get("siteId"));
			}
			axios({
				method: "post",
				url: `${process.env.ROOT_API}api/site/${siteId}/image/upload`,
				data: formData,
				headers: {
					Authorization: "Bearer " + token,
					// 'Content-Type': 'application/x-www-form-urlencoded'
				},
			})
				.then((response) => {
					if (response.data.status == 1) {
						for (
							let i = 0;
							i < response.data.file_source.length;
							i++
						) {
							this.itensGroup.push({
								type: "image",
								contents: {
									heigth: "",
									url: response.data.file_source[i],
									width: "",
								},
							});
						}
					}
				})
				.catch((response) => {
					console.log("Falha ao subir imagens para a galeria");
				})
				.finally(() => {
					document.getElementsByClassName("uploadInput").value = "";
					setTimeout(() => {
						this.$emit("handleLoading", false);
					}, 2000);
				});
		},
	},
};
</script>
<style>
.media--manager {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 50;
	background-color: #fff;
	overflow-y: auto;
}

.hover-shadow {
	transition: 0.3s;
}

.hover-shadow:hover {
	box-shadow: 0px 5px 15px #0000002e;
	border-radius: 4px;
	cursor: pointer;
}

.img-galery {
	object-fit: cover;
	max-height: 250px;
	width: 100%;
}
.btn-outline-primario {
	background-color: #fff;
	border: 1px solid rgba(93, 64, 255, 0.5);
	transition: all 300ms;
}
.btn-outline-primario i {
	color: rgba(93, 64, 255, 0.5);
}
.btn-outline-primario:hover {
	background-color: rgba(93, 64, 255, 0.5);
	border: 1px solid rgba(93, 64, 255, 0.5);
}

.btn-outline-primario:hover i {
	color: #fff;
}

.close {
	/* color: #fff!important; */
}

@media (max-width: 425px) {
	.next,
	.prev {
		display: none !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/GroupHome.vue